import React, { useEffect, useState } from "react";
import NewTitle from "../../extra/Title";
import { useTabSelectWithClearSearch } from "../../../util/useTabSelectWithClearSearch";
import SoundCategory from "./SoundCategory";
import SoundList from "./SoundList";
import dayjs from "dayjs";
import { useDispatch, useSelector } from "react-redux";
import { getSoundStatsData } from "../../store/sound/sound.action";
import StatsCards from "../../extra/StatsCards";
import {
  IconMusic,
  IconCategory,
  IconCircleCheck,
  IconCircleX,
  IconStar,
  IconTrophy,
} from "@tabler/icons-react";

export default function SoundPage() {
  const dispatch = useDispatch();
  const { multiButtonSelect, handleMultiButtonSelect } =
    useTabSelectWithClearSearch("Sound List");
  const [startDate, setStartDate] = useState("All");
  const [endDate, setEndDate] = useState("All");
  const { soundStatsData } = useSelector((state) => state.sound);

  const startDateFormat = (startDate) => {
    return startDate && dayjs(startDate).isValid()
      ? dayjs(startDate).format("YYYY-MM-DD")
      : "All";
  };
  const endDateFormat = (endDate) => {
    return endDate && dayjs(endDate).isValid()
      ? dayjs(endDate).format("YYYY-MM-DD")
      : "All";
  };

  const startDateData = startDateFormat(startDate);
  const endDateData = endDateFormat(endDate);

  useEffect(() => {
    dispatch(getSoundStatsData(startDateData, endDateData));
  }, [dispatch, startDateData, endDateData]);

  const statsCards = [
    {
      title: "Total Sound List",
      count: soundStatsData?.totalSoundList,
      Icon: IconMusic,
    },
    {
      title: "Total Sound Category",
      count: soundStatsData?.totalSoundCategory,
      Icon: IconCategory,
    },
    {
      title: "Total Active Sound Category",
      count: soundStatsData?.totalActiveSoundCategory,
      Icon: IconCircleCheck,
    },
    {
      title: "Total Inactive Sound Category",
      count: soundStatsData?.totalInactiveSoundCategory,
      Icon: IconCircleX,
    },
    {
      title: "Most Used Sound List",
      count: soundStatsData?.mostUsedSoundList,
      Icon: IconStar,
    },
    {
      title: "Most Used Sound Category",
      count: soundStatsData?.mostUsedSoundCategory,
      Icon: IconTrophy,
    },
  ];

  return (
    <div className="userPage channelPage">
      <div>
        <div className="dashboardHeader primeHeader mb-3 p-0">
          <NewTitle
            dayAnalyticsShow={true}
            setEndDate={setEndDate}
            setStartDate={setStartDate}
            startDate={startDate}
            endDate={endDate}
            multiButtonSelect={multiButtonSelect}
            setMultiButtonSelect={handleMultiButtonSelect}
            labelData={["Sound List", "Sound Category"]}
          />
        </div>
        <StatsCards cards={statsCards} colClass="col-xl-4 col-sm-6 col-12" />
      </div>
      {multiButtonSelect == "Sound List" && (
        <SoundList startDate={startDateData} endDate={endDateData} />
      )}
      {multiButtonSelect == "Sound Category" && (
        <SoundCategory startDate={startDateData} endDate={endDateData} />
      )}
    </div>
  );
}
